import { GETTERS_AVAILABLE_SYMBOLS } from './types';

export default {
  [GETTERS_AVAILABLE_SYMBOLS]: ({ symbols }) => symbols,
};
